import { Component, OnInit } from '@angular/core';

import { Module } from '../module.component';

import { Status } from './../../service/status.service';
import { Locale } from './../../service/locale.service';

import { MaterialListService } from '../material-list/material-list.service';
// model imports
import { ModalMaterialDocComponent } from '../MODAL-material-doc/modal-material-doc.component';

@Component({
  selector: 'app-modal-bom-explosion',
  templateUrl: './modal-bom-explosion.component.html'
})
export class ModalBomExplosionComponent extends Module {

    public visible = false;
    public visibleAnimate = false;

    selectedMaterial = undefined;

    constructor(private locale: Locale,
                private status: Status,
                private materialListService: MaterialListService) {

        super();
        this.setBindExposer(this.status.getExposer());
        // this.getExposer().getModelsManager().bom_request;
    }

    public show() {
        this.visible = true;
        setTimeout(() => this.visibleAnimate = true, 100);
    }

    public hide() {
        this.visibleAnimate = false;
        setTimeout(() => this.visible = false, 100);
    }

    init(material) {
        this.getModelsManager().bom_request.supplier_code = this.getAccountService().supplierProperties.supplier_code;
        this.getModelsManager().bom_request.company_code = this.getAccountService().getUserCompany().code;
        this.getModelsManager().bom_request.language = this.getLocale().getPreferredLanguage();
        this.getModelsManager().bom_request.material_code = material.material_code;
        this.getModelsManager().bom_request.division_code = material.division_code;
        this.getModelsManager().bom_request.material = material;

        this.selectedMaterial = material;
        this.searchBomExplosion();
    }

    getBomMaterials() {
        return this.materialListService.getBomMaterials();
    }

    searchBomExplosion() {
        this.materialListService.getBomExplosion();
    }

    isServiceSearching() {
        return this.materialListService.isSearching();
    }

    // shows the modal of the material's documents
    showDocs(modal: ModalMaterialDocComponent, materialCode, materialDescription) {
        modal.setDocs(materialCode,
                      materialDescription,
                      this.getAccountService().getUserCompany().code,
                      this.getLocale().getPreferredLanguage());
                      modal.show();
    }

    // download the material report
    downloadSchedaTecnica(divisionCode, materialCode, material_provision) {
        this.materialListService.downloadSchedaTecnica(
                                                this.selectedMaterial.division_code,
                                                materialCode,
                                                this.getLocale().getPreferredLanguage(),
                                                this.getAccountService().supplierProperties.supplier_code,
                                                material_provision);
                                                // this.materialListService.getBomMaterials()[0].material_provision);
    }

    downloadScalareReport(divisionCode, materialCode) {
        this.materialListService.downloadScalareReport(
                                                this.selectedMaterial.division_code,
                                                materialCode,
                                                this.getLocale().getPreferredLanguage(),
                                                this.getAccountService().supplierProperties.supplier_code,
                                                this.getAccountService().getUserCompany().code);
    }

    // returns the status of the server query
    isResultEmpty() {
        return this.materialListService.getBomMaterials().length === 0;
    }

    getNormalDate(value) {
        if (value !== null && value !== undefined) {
            const date = new Date(value);
            this.getDateTimeManager().setDate(date);
            const text = this.getDateTimeManager().ddmmyyyy('/');
            return text;
            } else {
                return '';
            }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-bom-explosion/modal-bom-explosion.component.ts